var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuToggleIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "left-panel-toggle-icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7071 16.7071C13.0976 16.3166 13.0976 15.6834 12.7071 15.2929L9.41421 12L12.7071 8.70711C13.0976 8.31658 13.0976 7.68342 12.7071 7.29289C12.3166 6.90237 11.6834 6.90237 11.2929 7.29289L7.29289 11.2929C6.90237 11.6834 6.90237 12.3166 7.29289 12.7071L11.2929 16.7071C11.6834 17.0976 12.3166 17.0976 12.7071 16.7071Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "left-panel-toggle-icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7071 16.7071C18.0976 16.3166 18.0976 15.6834 17.7071 15.2929L14.4142 12L17.7071 8.70711C18.0976 8.31658 18.0976 7.68342 17.7071 7.29289C17.3166 6.90237 16.6834 6.90237 16.2929 7.29289L12.2929 11.2929C11.9024 11.6834 11.9024 12.3166 12.2929 12.7071L16.2929 16.7071C16.6834 17.0976 17.3166 17.0976 17.7071 16.7071Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuToggleIcn);
export default __webpack_public_path__ + "static/media/menu-toggle-icn.22646085131cda64debc850d5ecff03e.svg";
export { ForwardRef as ReactComponent };